import { call, put, takeLatest } from "redux-saga/effects";
import { GET_MyTaskList, PUT_MyTaskProgress, POST_MyTaskProgress, GET_MyTaskProgressRecords } from "../services/MyTask";
import exception from "../utils/exception";
import { jwtDecode } from "../utils/jwt";
import { getToken } from "../utils/token";

function* GET_MyTaskListEffect({ payload, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_MyTaskList, token, payload);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_MyTaskList", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* PUT_MyTaskProgressEffect({ formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(PUT_MyTaskProgress, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* POST_MyTaskProgressEffect({ formData, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    yield call(POST_MyTaskProgress, token, formData);
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

function* GET_MyTaskProgressRecordsEffect({ taskId, callback, loading }) {
  if (loading) loading(true);
  try {
    const token = yield call(getToken);
    const res = yield call(GET_MyTaskProgressRecords, token, taskId);
    const resData = yield call(jwtDecode, res.data);
    yield put({ type: "SAVE_MyTaskProgressRecords", payload: resData.data });
    if (callback) callback();
  } catch (error) {
    yield call(exception, error);
  } finally {
    if (loading) loading(false);
  }
}

export default function* Example() {
  yield takeLatest("GET_MyTaskList", GET_MyTaskListEffect);
  yield takeLatest("PUT_MyTaskProgress", PUT_MyTaskProgressEffect);
  yield takeLatest("POST_MyTaskProgress", POST_MyTaskProgressEffect);
  yield takeLatest("GET_MyTaskProgressRecords", GET_MyTaskProgressRecordsEffect);
}
